import { Component, OnDestroy, OnInit } from '@angular/core';
import { CompaniesService } from '../service/companies.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment-timezone';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { urls } from 'src/app/utils/url-utils';
@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.css']
})
export class CompaniesListComponent implements OnInit, OnDestroy {

  search;
  status = "active";
  portal = 'nemt'
  companiesList = [];
  user;
  timeZone;
  todayDate;
  canView = false;
  // viewAccess = false;


  constructor(
    private companyService: CompaniesService,
    private companiesService:CompaniesService,
    private sharedDataService: SharedDataService
  ) {
    document.addEventListener('keyup', e => {
      console.log(e);
      // e.ctrlKey &&
      if (e.altKey && (e.key.toLowerCase() === 'v' || e.key.toLowerCase() === '√')) {
        this.canView = !this.canView;
      }
    });
   }

  ngOnInit() {

    this.sharedDataService
    .getUser()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.timeZone = this.user.timeZone;
        this.todayDate = moment().tz(this.timeZone);
        this.companiesListData();
      }
    });

  }


  companiesListData() {
    const queryParams = {
      accountStatus: this.status,
      isRemoveIAAL: true,
      isByPassId: true
    }
    this.companiesService.getCompanies(queryParams)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(
      (data) => {
        if (data) {
          this.companiesList = data;
          this.companiesList.sort((a, b) => <any>new Date(b.created) - <any>new Date(a.created));
          // this.companiesList.forEach(company => {
          //   company.focalPerson = "";
          //   company.focalPersonNumber = ""
          // });
         }
      },);
  }




  onChangeStatus() {
    this.companiesList = [];
    this.companiesListData()
  }

  onChangePlatform(){

  }
  getTrialStatus(date) {
    const trialEndDate = moment(date).tz(this.timeZone);
    return trialEndDate.diff(this.todayDate, 'days');
  }


  openProviderPanel(companyId, isNewPanel) {
    this.companyService.getCompanyToken(companyId)
    .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data: any) => {
        if (isNewPanel) {
          window.open(`${urls.PROVIDER_PANEL_URL}auth-token/${data.companyToken}`, '_blank');
        } else {
          window.open(`${urls.SERVER_URL}auth_token?authtoken=${data.companyToken}`, '_blank');
        }
      });
  }



  ngOnDestroy(): void {
  }
}
